import { Grid, Skeleton, Typography } from '@mui/material'

import UseCaseIcon from '../../../../components/use-case-icons'
import useIsMobile from '../../../../utils/hooks/useIsMobile'
import getNodeTypeMatrix from '../../../../utils/nodetype-matrix'
import DeviceDetailsMenu from '../device-details-menu'
import classes from '../index.styles'

interface IProps {
  device: IDeviceType | null
  refetchDevice?: () => void
}

const SummarySection = ({ device, refetchDevice }: IProps) => {
  const isMobile = useIsMobile()
  const deviceLocation = device?.node?.area || device?.node?.metadata?.device_location || ''
  const deviceLocationDetails = [device?.node?.floor ? `Floor ${device.node.floor}` : '', device?.node?.metadata?.device_location_note]
    .filter(Boolean)
    .join(' · ')

  return (
    <Grid container={true} size={12} sx={classes.summarySectionOuterGrid}>
      <Grid container={true} sx={classes.summarySectionInnerGrid}>
        {device ? <UseCaseIcon useCase={device?.deviceUseCase} /> : <Skeleton variant="rounded" width={24} height={24} />}

        <Grid container={true} sx={classes.summarySectionColumnGrid}>
          <Typography variant="caption" sx={classes.deviceType}>
            {device ? getNodeTypeMatrix[device?.node?.nodeTypeName ?? ''] : <Skeleton />}
          </Typography>

          {device ? (
            <Grid container={true} sx={classes.deviceLocationRow}>
              <Typography variant="body2" sx={classes.deviceLocation}>
                {deviceLocation && deviceLocationDetails ? `${deviceLocation} ·` : deviceLocation}
              </Typography>

              {deviceLocationDetails && (
                <Typography variant="caption" sx={classes.deviceLocationDetails}>
                  {deviceLocationDetails}
                </Typography>
              )}
            </Grid>
          ) : (
            <Skeleton />
          )}
        </Grid>
      </Grid>

      {!isMobile && (
        <Grid>{device ? <DeviceDetailsMenu device={device} refetchDevice={refetchDevice} /> : <Skeleton variant="circular" width={24} height={24} />}</Grid>
      )}
    </Grid>
  )
}

export default SummarySection
